export default __webpack_public_path__ + "static/media/acadiaCropped.17d8bc20.jpg";